var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{attrs:{"name":"slide-up-fade","tag":"div","mode":"out-in","id":"alert"}},_vm._l((_vm.$store.getters['alert/getMessages']),function(message,id){return _c('div',{key:id,staticClass:"alert",class:['alert-' + message.type],attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(message.text)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }